import { seo } from '../seo';
export { AiAssistantPage as default } from '../../src/pages/Product/AiAssistantPage';
export const meta = () => seo('ai');
